import { storage } from '@uhg-abyss/web/tools/storage';

import { Constants } from '../Constants';

export const getBccBadgeState = (
  isBccProvider: boolean,
  portalData: any,
  enableBccBadge: boolean
) => {
  const isBccEligible =
    !!portalData?.portalConfig?.isBccEligible ||
    !!storage.session.get(Constants.STORAGE_KEYS.SESSION.IS_BCC_ELIGIBLE);

  const shouldShowBccBadge = enableBccBadge && isBccProvider && isBccEligible;

  return shouldShowBccBadge;
};
